function startOfLocalDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Whole calendar days from the conversation's local date to today (0 = same calendar day). */
export function getLocalCalendarDaysAgo(isoString) {
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return 999;
  const today = startOfLocalDay(new Date());
  const conv = startOfLocalDay(d);
  return Math.round((today.getTime() - conv.getTime()) / 86400000);
}

/**
 * Maps IQ API conversations into IQSidebar buckets (Today, Previous 7 days, older).
 * Sorts newest first within each bucket using `updated_at` then `timestamp`.
 *
 * @param {Array<{ conversation_id: string, title?: string, timestamp?: string, updated_at?: string }>} conversations
 * @returns {{ today: Array<{ id: string, title: string }>, previous7: Array<{ id: string, title: string }>, previous30: Array<{ id: string, title: string }> }}
 */
export function bucketIQConversationsByRecency(conversations) {
  const empty = { today: [], previous7: [], previous30: [] };
  if (!Array.isArray(conversations) || conversations.length === 0) {
    return empty;
  }

  const sorted = [...conversations].sort((a, b) => {
    const tb = new Date(b.updated_at || b.timestamp || 0).getTime();
    const ta = new Date(a.updated_at || a.timestamp || 0).getTime();
    return tb - ta;
  });

  const today = [];
  const previous7 = [];
  const previous30 = [];

  for (const c of sorted) {
    const iso = c.updated_at || c.timestamp;
    const daysAgo = iso ? getLocalCalendarDaysAgo(iso) : 999;
    const item = {
      id: c.conversation_id,
      title: (c.title || "").trim() || "Untitled",
    };
    if (daysAgo <= 0) {
      today.push(item);
    } else if (daysAgo <= 7) {
      previous7.push(item);
    } else {
      previous30.push(item);
    }
  }

  return { today, previous7, previous30 };
}
